import { useFeatureAccess } from "@/hooks/use-feature-access";
import { Feature } from "@/types/user";

export function useDemoAccess() {
  const { hasAccess } = useFeatureAccess();

  const isSystemAdmin = hasAccess("system_admin");

  // Check for either system_admin OR deadline_guardian
  const hasDeadlineGuardian = hasAccess("system_admin") || hasAccess("deadline_guardian");

  // We'll keep the hasFeature function for backwards compatibility
  // and to allow checking for features not predefined in this hook
  const hasFeature = (feature: Feature) => hasAccess(feature);

  return {
    hasFeature,
    isSystemAdmin,
    hasDeadlineGuardian,
  };
}
